module.exports = __webpack_public_path__ + "img/asu_university_horiz_rgb_maroongold_150_4.ab480620.png";